import React, { useState, useEffect } from "react";

const InputEmail = ({
  name,
  value = "",
  onChange,
  placeholder,
  label,
  required = false,
  readOnly = false,
  setInputEmailError,
}) => {
  const [errMsg, setErrMsg] = useState("");

  const handleBlur = () => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    const trimmedValue = String(value).trim();
    if (required && trimmedValue === "") {
      setErrMsg("Email is required.");
      setInputEmailError((previousState) => ({
        ...previousState,
        email: true,
      }));
    } else if (trimmedValue && !emailRegex.test(trimmedValue)) {
      setErrMsg("Please enter a valid email address.");
      setInputEmailError((previousState) => ({
        ...previousState,
        email: true,
      }));
    } else {
      setErrMsg("");
      setInputEmailError((previousState) => ({
        ...previousState,
        email: false,
      }));
    }
  };

  const handleInputChange = (e) => {
    onChange(e); 
    if (errMsg) {
      setErrMsg("");
      setInputEmailError((previousState) => ({
        ...previousState,
        email: false,
      }));
    }
  };

  useEffect(() => {
    if (!errMsg) {
      setInputEmailError((previousState) => ({
        ...previousState,
        email: false,
      }));
    }
  }, [errMsg, setInputEmailError]); 

  return (
    <div className="form-group">
      <label htmlFor={name} className="col-form-label">
        {label}
      </label>
      <input
        type="email"
        className="form-control"
        name={name}
        value={value}
        onChange={handleInputChange}
        onBlur={handleBlur}
        placeholder={placeholder}
        required={required}
        readOnly={readOnly}
      />
      <small className="text-danger">{errMsg}</small>
    </div>
  );
};

export default InputEmail;